/**
 * useDjayLook — the SINGLE source for "how does Djay look for this learner right now".
 *
 * Thin wrapper around useDjaySelection() that returns the four look fields
 * (variant + accessory + tier + treatment) as ONE indivisible object. Identity
 * surfaces must consume the whole look, never a hand-picked subset — that ad-hoc
 * subsetting was the root cause of cosmetic drift across learner surfaces.
 *
 * See docs/audits/MASCOT_SSOT_ARCHITECTURE_AUDIT_2026.md §5.1.
 *
 * Product code should NOT call this directly in most cases — use <DjayIdentity>,
 * which consumes this hook internally. Expose it only for advanced call-sites that
 * need the raw look (e.g. forwarding into a non-avatar surface).
 */

import { useDjaySelection } from './useDjaySelection';
import type { DjayVariant, DjayAccessory, DjayTier, DjayTreatment } from './DjayAvatar';
export interface DjayLook {
  variant: DjayVariant;
  accessory: DjayAccessory;
  tier: DjayTier;
  treatment: DjayTreatment;
}
export function useDjayLook(): DjayLook {
  const {
    selectedVariant,
    selectedAccessory,
    selectedTier,
    selectedTreatment
  } = useDjaySelection();
  return {
    variant: selectedVariant,
    accessory: selectedAccessory,
    tier: selectedTier,
    treatment: selectedTreatment
  };
}